<template>
  <div id="app">
	  <router-view/>
  </div>
</template>

<script>
import './assets/style.scss'

export default {
	components:{
		
	},
}
</script>
